import React from 'react';
import { Document, Page, Text, View, StyleSheet, Font, Image, Link } from '@react-pdf/renderer';
import logo from '../../assets/logo/PrimeFullLogo.png';
import { format } from 'date-fns';

// Define styles

const dummyData = {
    className: 'TransactionWrapper',
    type: 'Charge',
    responseStatus: 'Approved',
    recurring: true,
    paymentTitle: 'Professional Registered Agent',
    orderPaymentFrequency: 'Monthly',
    orderName: 'ORD-000374582',
    orderId: 'a3uVB000001BwmTYAS',
    opportunityName: 'Business Consultation',
    opportunityId: '006VB00000BTujeYAD',
    name: 'TRX-001848210',
    id: 'a42VB000000UM4jYAG',
    gatewayDate: '2025-06-14T09:00:28.000Z',
    creditCardType: 'Visa',
    cardLast4: '1111',
    billingState: 'Rajasthan',
    billingProvince: 'sambhar lake jaipur',
    billingPostalCode: '303604',
    billingPhone: null,
    billingLast: 'Vaibhav Kumar Gaihnoliya randon text',
    billingFirst: 'Vaibhav Kumar Gaihnoliya randon text',
    billingCountry: 'India',
    billingCity: 'sambhar lake',
    billingAddressLine2: null,
    billingAddress: 'Test',
    amount: 24558100177892.95,
    accountName: 'AB Holdings, LLC AB Holdings, LLC AB Holdings, LLC',
    accountId: '001VB00000JNIJAYA5',
};

// Inserts soft break points to allow line wrapping for long numbers in PDF rendering
const formatNumberForWrap = (numStr, chunkSize = 10) => {
    return numStr.match(new RegExp(`.{1,${chunkSize}}`, 'g')).join(' ');
};
const TransactionPDF = ({ record }) => {
    const getAddress = () => {
        let data = [];
        if (record.billingCity) {
            data.push(record.billingCity);
        }
        if (record.billingProvince) {
            data.push(record.billingProvince);
        }
        if (record.billingState) {
            data.push(record.billingState);
        }
        if (record.billingPostalCode) {
            data.push(record.billingPostalCode);
        }
        return data.join(', ');
    };
    const getFullName = () => {
        let data = [];
        if (record.billingFirst) {
            data.push(record.billingFirst);
        }
        if (record.billingLast) {
            data.push(record.billingLast);
        }
        return data.join(' ');
    };

    record = {
        ...record,
        // ...dummyData,
        // dueDate: '2025-10-14T09:00:28.000Z',
        billingGateway: record.gateway,
    };
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View>
                    {/* Header */}
                    <View style={styles.header}>
                        <Image style={styles.logo} src={logo} />
                        <View style={{ ...styles.addressText, alignItems: 'right', marginTop: -10 }}>
                            {/* <View style={{ ...styles.addressText, color: 'black', marginBottom: 2 }}>
                                <Text style={{ right: 0 }}>Company Address</Text>
                            </View>
                            <View style={styles.addressText}>
                                <Text style={{ position: 'absolute', right: 0, textAlign: 'right', width: 100, lineHeight: '10px' }}>5250 S. Commerce Drive, Suite 200, Murray, UT 84107</Text>
                            </View> */}
                            <View style={styles.addressText}>
                                <Text style={{ position: 'absolute', right: 0, textAlign: 'right', width: 150, fontSize: '10px', lineHeight: '10px' }}>Prime Corporate Services</Text>
                            </View>
                        </View>
                    </View>

                    {/* Invoice Details */}
                    <View style={{ ...styles.container, ...styles.spaceBetween }}>
                        <View>
                            {/* <Text style={styles.boldText}>
                                Invoice ID - <Text style={{ color: '#5E6470' }}>{record.orderName}</Text>
                            </Text> */}
                            <Text style={{ ...styles.boldText }}>
                                Transaction ID - <Text style={{ color: '#5E6470' }}>{record.name}</Text>
                            </Text>
                        </View>
                        <View>
                            <Text>
                                Invoice Issue Date: <Text style={{ color: '#5E6470' }}>{record.gatewayDateString}</Text>
                            </Text>
                            {/* <Text style={{ marginTop: 4 }}>
                                Due Date: <Text style={{ color: '#5E6470' }}>{record.dueDate ? format(new Date(record.dueDate), 'MMM dd, yyyy hh:mm a') : ''}</Text>
                            </Text> */}
                        </View>
                    </View>

                    <View style={{ border: '1px solid #E5E5E5', borderRadius: 6, marginTop: 30 }}>
                        {/* Billing Information part 1*/}
                        <View style={{ ...styles.infoSection, borderBottom: '1px solid #E5E5E5', paddingBottom: 10 }}>
                            <View style={{ width: '30%', padding: 10 }}>
                                <Text style={{ ...styles.textMutedHeading }}>Billed to</Text>
                                {/* <Text style={{ ...styles.boldText, fontSize: 14 }}>{record.accountName}</Text> */}
                                <Text style={{ ...styles.boldText, fontSize: 14 }}>{getFullName()}</Text>

                                <Text style={{ ...styles.textMuted, marginTop: 6 }}>Billing address</Text>
                                <Text style={styles.textMuted}>{record.billingAddress + `${record.billingAddressLine2 ? ', ' + record.billingAddressLine2 : ''}`}</Text>
                                <Text style={styles.textMuted}>{getAddress()}</Text>
                                <Text style={styles.textMuted}>{record.billingPhone}</Text>
                            </View>
                            <View style={{ width: '30%', padding: 10 }}>
                                {/* <Text style={styles.textMutedHeading}>Service</Text>
                                <Text style={styles.boldText}>{record.paymentTitle}</Text> */}

                                <Text
                                    style={{
                                        ...styles.textMuted,
                                        // marginTop: 6,
                                        marginBottom: 4,
                                    }}
                                >
                                    Applies to:
                                </Text>
                                <Text style={styles.textMuted}>{record.accountName}</Text>
                            </View>
                            <View style={{ width: '20%', padding: 10 }}>
                                <Text style={styles.textMutedHeading}>Status</Text>
                                {record.type === 'Refund' ? <Text style={styles.statusRefund}>Refund</Text> : <Text style={styles.statusPaid}>Paid</Text>}
                            </View>
                            <View style={{ width: '20%', padding: 10 }}>
                                <Text style={styles.textMutedHeading}>Invoice of (USD)</Text>
                                <Text style={{ ...styles.amountText }}>
                                    {formatNumberForWrap(
                                        new Intl.NumberFormat('en-US', {
                                            style: 'currency',
                                            currency: 'USD',
                                            maximumFractionDigits: 2,
                                        }).format(record.amount)
                                    )}
                                </Text>
                            </View>
                        </View>

                        {/* Billing Information part 2*/}
                        <View style={{ ...styles.infoSection, marginTop: 10 }}>
                            <View style={{ width: '30%', padding: 10 }}>
                                <Text style={styles.textMutedHeading}>Card Details</Text>

                                <View>
                                    <Text style={{ ...styles.textMuted }}>
                                        <Text style={{ ...styles.textMuted, fontWeight: 'bold', color: '#000000' }}>Card Last Digits:</Text> {record.cardLast4}
                                    </Text>
                                </View>

                                <View>
                                    <Text style={{ ...styles.textMuted }}>
                                        <Text style={{ ...styles.textMuted, fontWeight: 'bold', color: '#000000' }}>Card Type:</Text> {record.creditCardType}
                                    </Text>
                                </View>

                                <View>
                                    <Text style={{ ...styles.textMuted }}>
                                        <Text style={{ ...styles.textMuted, fontWeight: 'bold', color: '#000000' }}>Billing gateway:</Text> {record.billingGateway}
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>

                    {/* Footer */}
                </View>
                <View style={styles.footer}>
                    <Text style={styles.textMuted}>
                        <Link src="https://www.primecorporateservices.com/">www.primecorporateservices.com</Link> | (855) 442-3515 | Contact Support: support@primecorporateservices.com
                    </Text>
                </View>
            </Page>
        </Document>
    );
};

const styles = StyleSheet.create({
    page: {
        padding: 30,
        backgroundColor: '#f8f9fa',
        fontSize: 11,
    },
    container: {
        backgroundColor: '#F2F4F7',
        padding: '12px 12px 12px 12px',
        borderRadius: 6,
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20,
    },
    spaceBetween: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    logo: {
        marginLeft: -30,
        width: 200,
    },
    addressText: {
        alignItems: 'right',
        fontSize: 8,
        color: '#5E6470',
    },
    section: {
        marginBottom: 10,
    },
    boldText: {
        fontWeight: 'bold',
    },
    table: {
        width: '100%',
        marginTop: 20,
    },
    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#f1f1f1',
        padding: 10,
        fontWeight: 'bold',
    },
    tableRow: {
        flexDirection: 'row',
        padding: 10,
        borderBottom: '1px solid #ddd',
    },
    tableCell: {
        flex: 1,
        textAlign: 'center',
    },
    footer: {
        position: 'absolute',
        bottom: 30,
        left: 30,
        right: 30,
        textAlign: 'center',
        fontSize: 8,
        backgroundColor: '#F2F4F7',
        padding: '12px 12px 12px 12px',
        borderRadius: 6,
    },
    totalSection: {
        marginTop: 10,
        flexDirection: 'row',
        justifyContent: 'space-between',
        fontWeight: 'bold',
    },
    infoSection: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'start',
        // marginBottom: 10,
        // marginTop: 30,
    },
    statusPaid: {
        backgroundColor: '#DFFFD6',
        color: 'green',
        padding: 4,
        borderRadius: 4,
        fontWeight: 'bold',
        alignSelf: 'flex-start', // ✅ This is the key
    },
    statusRefund: {
        backgroundColor: '#FF5630',
        color: 'white',
        padding: 4,
        borderRadius: 4,
        fontWeight: 'bold',
        alignSelf: 'flex-start', // ✅ This is the key
    },
    amountText: {
        fontWeight: '700',
        color: '#014DE5',
        fontSize: 18,
    },
    textMutedHeading: {
        color: '#6c757d',
        fontSize: 10,
        marginBottom: 4,
        fontWeight: 700,
        // borderBottom:"1px solid #6c757d",
        // paddingBottom:2,
    },
    textMuted: {
        color: '#6c757d',
        fontSize: 10,
        marginBottom: 2,
    },
});

export default TransactionPDF;
